import { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';
import copy from 'copy-to-clipboard';

import { useShareData } from '../../context';
import { useSessionStore } from '../../stores/SessionStore';
import { useUserStore } from '../../stores/UserStore';

import { WEAAccountInfoTemplate } from '../../components/Templates/WEA/WEAAccountInfoTemplate';

const AccountInfoScreen: React.FC = () => {
  const navigate = useNavigate();
  const isLoggedIn = useSessionStore((state) => state.isLoggedIn);
  const { t } = useTranslation();

  const { setSharedData } = useShareData();

  useEffect(() => {
    setSharedData(undefined);
  }, [setSharedData]);

  const onClickName = useCallback(() => {
    navigate('/wea-member/account/display-name');
  }, [navigate]);

  const onClickUsername = useCallback(() => {
    navigate('/wea-member/account/username');
  }, [navigate]);

  const onClickEmail = useCallback(() => {
    navigate('/wea-member/account/email');
  }, [navigate]);

  const onClickPassword = useCallback(() => {
    navigate('/wea-member/account/password');
  }, [navigate]);

  const onClickRegions = useCallback(() => {
    navigate('/wea-member/account/region');
  }, [navigate]);

  const activeUserId = useSessionStore((store) => store.activeUserId);

  const userAccount = useUserStore((state) =>
    state.getAccount(activeUserId ?? ''),
  );

  const onClickShare = useCallback(() => {
    const pageUrl = window.location.href;

    const updatedUrl = new URL(pageUrl);
    updatedUrl.pathname = '/wea-member';

    const queryParams = new URLSearchParams();
    queryParams.set('referralCode', userAccount?.userCode ?? '');
    updatedUrl.search = queryParams.toString();

    if (navigator.share) {
      navigator.share({ url: updatedUrl.toString() }).catch((err) => {
        console.error('Failed to share the URL: ', err);
      });
    } else {
      navigator.clipboard
        .writeText(updatedUrl.toString())
        .then(() => {
          // setCopied(true);
          // setTimeout(() => setCopied(false), 2000); // reset after 2s
          toast.success(t('Link is copied!'));
        })
        .catch((err) => {
          console.error('Failed to copy the URL: ', err);
        });
    }
  }, [t, userAccount?.userCode]);

  const referralCode = userAccount?.userCode ?? '';

  const onPressCopy = () => {
    copy(referralCode ?? '');
    toast.success(t('Referral code is copied!'));
  };

  useEffect(() => {
    if (!isLoggedIn()) {
      navigate('/wea-member/start');
    }
  }, [isLoggedIn, navigate]);

  return (
    <WEAAccountInfoTemplate
      onClickName={onClickName}
      onClickUsername={onClickUsername}
      onClickEmail={onClickEmail}
      onClickPassword={onClickPassword}
      onClickRegions={onClickRegions}
      onClickShare={onClickShare}
      onPressCopy={onPressCopy}
      referralCode={referralCode}
    />
  );
};
export default AccountInfoScreen;
